import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _directive_wechat_title = _resolveDirective("wechat-title");
  return _withDirectives((_openBlock(), _createBlock(_component_router_view, null, null, 512)), [[_directive_wechat_title, _ctx.$route.meta.title]]);
}